import { render, staticRenderFns } from "./newRoleDialog.vue?vue&type=template&id=2a9b1a46&scoped=true"
import script from "./newRoleDialog.vue?vue&type=script&lang=js"
export * from "./newRoleDialog.vue?vue&type=script&lang=js"
import style0 from "./newRoleDialog.vue?vue&type=style&index=0&id=2a9b1a46&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a9b1a46",
  null
  
)

export default component.exports